"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertProtectedIntrusions = convertProtectedIntrusions;
const reviews_1 = require("../../reviews");
const common_1 = require("./common");
function convertProtectedIntrusions(nodes) {
    return (problem) => {
        const designatorUidMap = {};
        const affectedNodeUids = problem.affectedItems
            .filter((item) => item.type === "pcbLayoutNode")
            .map((item) => item.uid);
        const [protectedNodeUid, intruderNodeUid] = affectedNodeUids;
        const protectedDesignator = protectedNodeUid
            ? (0, common_1.sanitizeDesignator)((0, common_1.getLabelForPcbNode)(nodes[protectedNodeUid]))
            : null;
        const intruderDesignator = intruderNodeUid
            ? (0, common_1.sanitizeDesignator)((0, common_1.getLabelForPcbNode)(nodes[intruderNodeUid]))
            : null;
        if (protectedDesignator && protectedNodeUid) {
            designatorUidMap[protectedDesignator] = protectedNodeUid;
        }
        if (intruderDesignator && intruderNodeUid) {
            designatorUidMap[intruderDesignator] = intruderNodeUid;
        }
        return {
            name: `${protectedDesignator} ← ${intruderDesignator}`,
            protected: protectedDesignator || null,
            intruder: intruderDesignator || null,
            status: reviews_1.ReviewStatus.WARNING,
            designatorUidMap,
        };
    };
}
//# sourceMappingURL=protectedIntrusions.js.map